import FormContainer from '@/core/components/FormContainer/FormContainer';

export default FormContainer;
